import React from 'react';

interface InputFieldProps {
    label?: string;
    value: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    maxLength?: number;
    required?: boolean;
    helperText?: string;
    name?: string;
    type?: string;
    className?: string;
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
    error?: boolean;
    disabled?: boolean;
    labelClassName?: string;
    showRequiredIndicator?: boolean; // New Prop
    errorMessage?: string;
}

const InputField: React.FC<InputFieldProps> = ({
    label,
    value,
    onChange,
    placeholder,
    maxLength,
    required = false,
    disabled,
    name,
    helperText,
    type = 'text',
    className = 'w-full max-w-md',
    error = false,
    errorMessage,
    showRequiredIndicator = true,
}) => {
    const isError = error || !!errorMessage;
    return (
        <div className={`flex flex-col ${className}`}>
            {label && (
                <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5 ml-1">
                    {label} {required && showRequiredIndicator && <span className="text-rose-500">*</span>}
                </label>
            )}
            <input
                type={type}
                name={name}
                maxLength={maxLength}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                required={required}
                disabled={disabled}
                className={`px-4 py-3 bg-slate-50 border rounded-2xl outline-none font-bold text-sm text-slate-700 transition-all duration-200 ${
                    isError
                        ? 'border-rose-300 bg-rose-50/20 focus:border-rose-500 focus:ring-4 focus:ring-rose-500/5'
                        : 'border-slate-200/60 focus:border-primary focus:bg-white focus:ring-4 focus:ring-primary/5 focus:shadow-sm'
                } disabled:opacity-50 disabled:bg-slate-100 disabled:cursor-not-allowed`}
            />
            {isError && errorMessage && (
                <p className="text-xs text-rose-500 font-medium mt-1.5 ml-1 flex items-center gap-1">
                    <span>⚠️</span> {errorMessage}
                </p>
            )}
            {helperText && !isError && (
                <p className="text-slate-400 text-[10px] font-bold uppercase tracking-wider mt-1 ml-1">{helperText}</p>
            )}
        </div>
    );
};

export default InputField;
